// extracted by mini-css-extract-plugin
export default {"tile":"Tile_tile__C6nOA","highlight":"Tile_highlight__YxwYH"};